module.exports = __webpack_public_path__ + "img/calendar-edit.7f3c23f4.svg";